import React from "react";
import { Typography, Layout } from "antd";

const { Header } = Layout;
const { Title } = Typography;

const BiotechHeader = () => {
    return (
        <Header style={{ background: "#1890ff", textAlign: "center", padding: "10px" }}>
            <Title level={2} style={{ color: "white", margin: 0 }}>
                Swedish Biotech
            </Title>
        </Header>
    );
};

export default BiotechHeader;